import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userslice";
import authReducer from "./slices/authSlice";
import faqReducer from "./slices/faqSlice.js"
import galleryReducer from "./slices/gallerySlice"
import providerReducer from './slices/ProvidergalSlice.js'
import inquiryReducer from "./slices/inquirySlice"

const store = configureStore({
  reducer: {
    auth: authReducer,
    userlist: userReducer,
    faqs: faqReducer,
    gallery: galleryReducer,
    providerGallery: providerReducer,
    inquiries: inquiryReducer,
  },
});

export default store;
